// extracted by mini-css-extract-plugin
module.exports = {"base":"base--OppbNs","bg-white":"bg-white--z4bau6","bg-creme":"bg-creme--XxKxwz"};